// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1b8Qd","item":"PaymentsMobile_item__1-QUt","label":"PaymentsMobile_label__1aex4","amount":"PaymentsMobile_amount__2rri_"};